import _ from 'underscore';
import { IReturnProductType } from '@ve/pages/hotel/types';

export default (products: IReturnProductType[]) => {
    if (!products?.length) return [];

    return _.values(products.reduce((group, product) => {
        const {
            nights, nightInHotel, meal, room,
        } = product;
        const tourKey = `${nights}_${nightInHotel}_${meal.id}`;
        const roomsView = room.tags?.view || null;

        if (group[`${tourKey}_${roomsView}`]) {
            group[`${tourKey}_${roomsView}`].push(product);
        } else {
            group[`${tourKey}_${roomsView}`] = [product];
        }

        if (group[`${tourKey}_null`] && roomsView) {
            group[`${tourKey}_null`].push(product);
        }

        return group;
    }, {} as Record<string, IReturnProductType[]>));
};